<template>
  <!-- <div class="participant-mini" v-if="data != null && data != undefined" style="cursor: pointer;" @click="$store.dispatch('getParticipant', data.id)" >
    <p class="mb-0">
      <b>{{data.firstName}} {{data.lastName}}</b>
    </p>
    <el-tag v-if="$store.state.tags.items.some(x => x.id == data.tagID)" size="mini" :color="$store.state.tags.items.find(x => x.id == data.tagID).color" effect="dark" :style="'border-color: ' + $store.state.tags.items.find(x => x.id == data.tagID).color" >{{ $store.state.tags.items.find(x => x.id == data.tagID).title }}</el-tag>
  </div>
   -->

  <div class="participant-card-mini" :class="{ mini: type == 1 }" v-if="data != null && data != undefined" @click.stop="setMe">
    <div class="participant-card-mini-left" v-if="$store.state.tags.items.some(x => x.id == data.tagID)">
      <el-tooltip effect="dark" :content="$store.state.tags.items.find(x => x.id == data.tagID).title" placement="top">
        <span :style="{ 'background-color': $store.state.tags.items.find(x => x.id == data.tagID).color }"></span>
      </el-tooltip>
    </div>
    <div class="participant-card-mini-right">
      <div class="participant-card-mini-num"># {{ data.participantNO }}</div>
      <div class="participant-card-mini-title">
        <template v-if="participantIndex != null"><i class="fas fa-chair text-holacon"></i> {{ participantIndex + 1 }}-</template>{{ data.firstName }} {{ data.lastName }}
      </div>
      <div class="participant-card-mini-container">
        <span><i class="fas fa-circle" :style="{ color: $store.state.tags.items.find(x => x.id == data.tagID).color }"></i> {{ $store.state.tags.items.find(x => x.id == data.tagID).title }} <b v-if="data.subTagIds != undefined && data.subTagIds != null && data.subTagIds.length > 0">(+{{data.subTagIds.length}})</b></span>
      </div>
      <div class="selected-arrow" v-if="selected">
        <i class="fas fa-long-arrow-alt-right"></i>
      </div>
      <div class="selected-arrow check" v-if="listSelect">
        <i class="fas fa-check"></i>
      </div>

      <el-tooltip class="item" effect="dark" :content="$t('buttonGeneral.remove')" placement="right">
        <div class="selected-arrow remove" v-if="removeSelect" @click.stop="removeMe">
          <i class="fas fa-minus-square"></i>
        </div>
      </el-tooltip>
    </div>
  </div>

  <div v-else>
    {{ this.$t("noInfo") }}
  </div>
</template>

<script>
export default {
  name: "ParticipantMini",
  props: ["data", "type", "selected", "listSelect", "removeSelect", "participantIndex"],
  methods: {
    setMe() {
      this.$emit("setMe", this.data.id);
    },
    removeMe() {
      this.$emit("remove");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ParticipantMini.vue